var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-template',{attrs:{"current-page":_vm.page,"is-check-input-box":false,"loading":_vm.loading,"table-config":_vm.tableConfig,"table-data":_vm.tableData,"total":_vm.total},on:{"onChangePage":_vm.handleCurrentChange,"onExportData":_vm.onExport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }